import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Currency } from '../../services/currency.service';
import { CreateOfferPackage } from '../offer';

/** Seller-funded share of shipping (buyer pays the remainder). */
export const SHIPPING_SUBSIDY_PERCENT_OPTIONS = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100] as const;

export class PriceData {
    referenceCurrency: Currency;
    vat: number | null;
    daysToShip: number;
    /** Percent of shipping cost covered by the seller (0–100). */
    shippingSubsidyPercent: number;
    stocks: number;
    sku?: string;
    samplePrice: string;
    minWholesaleQuantity: number;
    wholesalePrices: { min: number; max: number; price: string }[];
    referencePrice: string;
    variants: { [key: string]: { price: string; stocks: number; sku: string } };
    packages: CreateOfferPackage[];
}

export interface PriceForm {
    referencePrice: FormControl;
    referenceCurrency: FormControl;
    vat: FormControl;
    variants: FormGroup;
    minWholesaleQuantity?: FormControl;
    samplePrice?: FormControl;
    wholesalePrices?: FormArray;
    stocks?: FormControl;
    sku?: FormControl;
    packages?: FormArray;
    daysToShip?: FormControl;
    shippingSubsidyPercent?: FormControl;
}
